export const KpiNames = {
  plant_availability: {
    name: 'Plant Availability (%)',
  },
  grid_availability: {
    name: 'Grid Availability (%)',
  },
  net_energy: {
    name: 'Net Energy (kWh)',
  },
  specific_yield: {
    name: 'Specific Yield (kWh/kWp)',
  },
  specific_power: {
    name: 'Specific Power(kW/kWp)',
  },
  performance_ratio: {
    name: 'Performance Ratio (%)',
  },
  temp_corr_ratio: {
    name: 'Temp Corr PR (%)',
  },
  energy_export: {
    name: 'Energy Export (kWh)',
  },
  energy_import: {
    name: 'Energy Import(kWh)',
  },
  irradiation: {
    name: 'Tilt POA Irradiation(kWh/m^2)',
  },
  expected_energy: {
    name: 'Expected Energy(kWh)'
  },
  dc_cuf_daily: {
    name: ' DC CUF (%)'
  },
  ac_cuf_daily: {
    name: ' AC CUF (%)'
  }
};

export const realtimeOmpMapping = {
  "DP_ACTIVE_POWER": {
    name: "Active Power (KW)",
    icon: "Zap",
  },
  "DP_APPARENT_POWER": {
    name: "Apparent Power (KVA)",
    icon: "Zap",
  },
  "DP_REACTIVE_POWER_2": {
    name: "Reactive Power (KVAR)",
    icon: "Zap",
  },
  "DP_AVERAGE_PHASE_RYB_FREQUENCY_2": {
    name: "Frequency (Hz)",
    icon: "Activity",
  },
  "DP_RMS_PHASE_RYB_VOLTAGE": {
    name: "Voltage (KV)",
    icon: "TrendingUp",
  },
  "DP_SPECIFIC_POWER": {
    name: "Specific Power (KW /KWP)",
    icon: "Sun",
  },
};

export const weatherMonitoring = {
  "WS_LIVE_POA_POWER_DENSITY": {
    name: "Tilt POA Irradiance (kW/m^2)",
    icon: "Sun",
  },
  "WS_AMBIENT_TEMPERATURE": {
    name: "Ambient Temperature (°C)",
    icon: "Thermometer",
  },
  "WS_MODULE_TEMPERATURE_01": {
    name: "Module Temperature (°C)",
    icon: "Thermometer",
  },
  "WS_WIND_SPEED": {
    name: "Wind Speed (m/s)",
    icon: "Wind",
  },
  "WS_WIND_DIRECTION": {
    name: "Wind Direction(NW)",
    icon: "Navigation",
  },
  "WS_LIVE_GHI_POWER_DENSITY": {
    name: "Global Horizontal Irradiance (kW/m^2)",
    icon: "Sun",
  }
};
